import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../../../hooks';
import { createStyleSheet } from '../../../../utils';
import { Titles } from './Titles';
import { Indicators } from './Indicators';
import { Days } from './Days';
export const Placeholder = ({ style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Titles, null),
        React.createElement(View, { style: styles.wrapper },
            React.createElement(Indicators, null),
            React.createElement(Days, null))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'flex-end'
    },
    wrapper: {
        flex: 1,
        marginLeft: size.C
    }
}));
//# sourceMappingURL=index.js.map